// Add only real reviews: { name, business, city, text }
export const testimonials = [];
